import { fetchApi } from "containers/helpers";

export const getStudios = () => fetchApi('/studios')